import moment from 'moment'
import 'moment/locale/es'
import { dineroDisabledMask } from '../Components/Items'

moment.locale('es')

const reporteDeFlujoDeTesorefiaPdf = (values) => {
    const empresa = values.empresa
    const bancos = values.bancos || []
    const dias = values.dias || []
    const totales = values.totales || {}

    const saldoTotal = bancos.reduce((sum, b) => sum + (b.saldo || 0), 0)

    // Filas tabla de bancos
    const bancosRows = bancos.map(b => [
        { text: b.banco, style: 'textoTabla' },
        { text: b.nombre, style: 'textoTabla' },
        { text: b.moneda, style: 'textoTabla', alignment: 'center' },
        { text: dineroDisabledMask(b.saldo), style: 'textoTabla', alignment: 'right' },
    ])
    bancosRows.push([
        { text: 'TOTAL EN BANCOS', style: 'tituloTabla', colSpan: 3, alignment: 'center' }, {}, {},
        { text: dineroDisabledMask(saldoTotal), style: 'tituloTabla', alignment: 'right' },
    ])

    // Filas tabla de proyección diaria
    const diasRows = dias.map((d, i) => [
        { text: moment(d.fecha, 'YYYY-MM-DD').format('DD/MM/YYYY'), style: 'textoTabla', alignment: 'center' },
        { text: dineroDisabledMask(d.saldoInicial), style: 'textoTabla', alignment: 'right' },
        { text: dineroDisabledMask(d.porCobrar), style: 'textoTabla', alignment: 'right', color: '#237804' },
        { text: dineroDisabledMask(d.porPagar), style: 'textoTabla', alignment: 'right', color: '#a8071a' },
        {
            text: dineroDisabledMask(d.saldoFinal),
            style: 'textoTabla',
            alignment: 'right',
            bold: true,
            color: d.saldoFinal >= 0 ? '#096dd9' : '#a8071a',
        },
    ])

    const layoutTabla = {
        fillColor: (ri) => ri % 2 === 0 ? '#f0f0f0' : '#ffffff',
        hLineWidth: () => 0.5,
        vLineWidth: () => 0.5,
        hLineColor: () => '#d9d9d9',
        vLineColor: () => '#d9d9d9',
    }

    const nombreEmpresa = empresa.nombreComercial
        ? empresa.nombreComercial
        : empresa.persona
            ? empresa.nombre
            : `${empresa.nombre} ${empresa.apellidoPaterno} ${empresa.apellidoMaterno}`

    const dd = {
        content: [
            // ── Encabezado ──
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    body: [[
                        {
                            border: [false, false, false, false],
                            image: 'logo',
                            fit: [80, 80],
                        },
                        {
                            border: [false, false, false, false],
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{ text: nombreEmpresa, style: 'tableHeader' }],
                                    [{ text: `R.F.C: ${empresa.rfc}`, style: 'textoChico', alignment: 'center' }],
                                    [{ text: `${empresa.calle} ${empresa.numeroCalle}${empresa.numeroInterior ? ' ' + empresa.numeroInterior : ''}`, style: 'textoChico', alignment: 'center' }],
                                    [{ text: `${empresa.colonia.tipoAsentamiento} ${empresa.colonia.nombre} C.P. ${empresa.colonia.cp} ${empresa.municipio.nombre} ${empresa.estado.abreviatura}`, style: 'textoChico', alignment: 'center' }],
                                    [{ text: 'FLUJO DE EFECTIVO — TESORERÍA', style: 'tableHeader', color: '#00BFD6' }],
                                ],
                            },
                            layout: 'noBorders',
                        },
                        {
                            border: [false, false, false, false],
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{ text: 'Período:', style: 'subheader', alignment: 'center' }],
                                    [{ text: `${moment(values.fechaInicio).locale('es').format('ll')}`, style: 'textoChico', alignment: 'center' }],
                                    [{ text: `al ${moment(values.fechaFinal).locale('es').format('ll')}`, style: 'textoChico', alignment: 'center' }],
                                    [{ text: 'Impresión:', style: 'subheader', alignment: 'center' }],
                                    [{ text: moment().locale('es').format('ll'), style: 'textoChico', alignment: 'center' }],
                                ],
                            },
                            layout: 'noBorders',
                        },
                    ]],
                },
            },
            // ── Saldo en Bancos ──
            { text: 'Saldo Actual en Bancos', style: 'sectionTitle' },
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '42%', '13%', '25%'],
                    body: [
                        [
                            { text: 'Banco', style: 'tituloTabla' },
                            { text: 'Cuenta', style: 'tituloTabla' },
                            { text: 'Moneda', style: 'tituloTabla' },
                            { text: 'Saldo Actual', style: 'tituloTabla' },
                        ],
                        ...bancosRows,
                    ],
                },
                layout: layoutTabla,
            },
            // ── Resumen del período ──
            { text: 'Resumen del Período', style: 'sectionTitle' },
            {
                style: 'tableExample',
                table: {
                    widths: ['55%', '45%'],
                    body: [
                        [
                            { text: 'Total Por Cobrar (CXC)', style: 'subheader', fillColor: '#f6ffed' },
                            { text: dineroDisabledMask(totales.totalPorCobrar || 0), style: 'textoTabla', alignment: 'right', fillColor: '#f6ffed', color: '#237804', bold: true },
                        ],
                        [
                            { text: 'Total Por Pagar (CXP)', style: 'subheader', fillColor: '#fff1f0' },
                            { text: dineroDisabledMask(totales.totalPorPagar || 0), style: 'textoTabla', alignment: 'right', fillColor: '#fff1f0', color: '#a8071a', bold: true },
                        ],
                        [
                            { text: 'Saldo Final Proyectado', style: 'tituloTabla' },
                            { text: dineroDisabledMask(totales.saldoFinalProyectado || 0), style: 'tituloTabla', alignment: 'right' },
                        ],
                    ],
                },
                layout: {
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                    hLineColor: () => '#d9d9d9',
                    vLineColor: () => '#d9d9d9',
                },
            },
            // ── Proyección diaria ──
            { text: 'Proyección Diaria', style: 'sectionTitle' },
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '20%', '20%', '20%', '22%'],
                    body: [
                        [
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Saldo Inicial', style: 'tituloTabla' },
                            { text: 'Por Cobrar (CXC)', style: 'tituloTabla' },
                            { text: 'Por Pagar (CXP)', style: 'tituloTabla' },
                            { text: 'Saldo Final', style: 'tituloTabla' },
                        ],
                        ...diasRows,
                    ],
                },
                layout: layoutTabla,
            },
        ],
        images: {
            logo: empresa.logo.base64Completa,
        },
        styles: {
            tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' },
            subheader: { fontSize: 8, bold: true },
            tableExample: { margin: [0, 5, 0, 5] },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: '#d9d9d9',
                style: 'subheader',
                alignment: 'center',
            },
            textoTabla: { fontSize: 8 },
            textoChico: { fontSize: 8 },
            sectionTitle: { fontSize: 10, bold: true, color: '#262626', margin: [0, 10, 0, 3] },
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 20],
    }

    return dd
}

export default reporteDeFlujoDeTesorefiaPdf
